import 'css-chunksrc/client/common/weekCalendar/days/styles.scss';export default {
  "calendar": "_calendar_nqimt_1",
  "heading": "_heading_nqimt_7",
  "title": "_title_nqimt_18",
  "iconBox": "_iconBox_nqimt_32",
  "icon": "_icon_nqimt_32",
  "rightIcon": "_rightIcon_nqimt_53",
  "leftIcon": "_leftIcon_nqimt_57",
  "grid": "_grid_nqimt_61",
  "headerRow": "_headerRow_nqimt_65",
  "dayName": "_dayName_nqimt_68",
  "weekRow": "_weekRow_nqimt_81",
  "day": "_day_nqimt_68",
  "otherMonth": "_otherMonth_nqimt_105",
  "selectedWeek": "_selectedWeek_nqimt_109",
  "footer": "_footer_nqimt_124",
  "button": "_button_nqimt_136"
};